/**
 * 用户账户相关
 */
import api from '@/api'

let ai = {}

ai.sent = async function (param) {
    return api.post(`/ai/sent`, param)
}

ai.chatlist = async function (param) {
    return api.post(`/ai/chatlist`, param)
}

export default ai
